module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', {
    staticClass: "insights-unit"
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "unit-head"
  }, [(_vm.hasValidData) ? _c('el-popover', {
    attrs: {
      "width": "260",
      "placement": "bottom-end",
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "fa fa-info-circle pull-right",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "",
      "popper-class": "text-format-wrap"
    },
    slot: "default"
  }, [_vm._v(_vm._s(_vm.dataByPeriod.description.replace("the business account's", "your account's") ))])]) : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "unit-title",
    on: {
      "click": _vm.handleTitleClick
    }
  }, [_vm._v(_vm._s(_vm.dataByPeriod.title))])], 1)]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(_vm.hasValidData) ? _c('div', [_c('h1', {
    staticClass: "no-margins"
  }, [_vm._v(_vm._s(Math.round(_vm.dataByPeriod.value).toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "stat-percent font-bold",
    class: {
      'text-success': _vm.dataByPeriod.difference > 0,
        'text-danger': _vm.dataByPeriod.difference < 0,
        'text-muted': _vm.dataByPeriod.difference === 0,
    }
  }, [_vm._v("\n        " + _vm._s(_vm.dataByPeriod.difference > 0 ? '+' : '') + _vm._s(_vm.dataByPeriod.difference.toLocaleString()) + "\n        "), _c('el-tooltip', {
    attrs: {
      "content": ("compared to previous " + _vm.period),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-level-up': _vm.dataByPeriod.difference > 0,
        'fa-level-down': _vm.dataByPeriod.difference < 0,
        'fa-minus': _vm.dataByPeriod.difference === 0,
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "sparkline"
  }, [_c('trend', {
    attrs: {
      "data": _vm.dataByPeriod.values,
      "gradient": ['#683090', '#c97eff'],
      "height": 60,
      "auto-draw": ""
    }
  })], 1)]) : _c('div', {
    staticClass: "no-data-placeholder"
  }, [_c('h3', {
    staticClass: "text-muted"
  }, [_vm._v("-")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce228998","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/social/instagram/InsightsOverviewItem.vue
// module id = 3397
// module chunks = 3